import { useMemo } from 'react';

interface NotificationDisplayProps {
  content: string;
  className?: string;
}

export default function NotificationDisplay({ content, className = '' }: NotificationDisplayProps) {
  const renderedContent = useMemo(() => {
    if (!content) return null;
    

    // Lexical形式かプレーンテキストかを判定
    try {
      const parsed = JSON.parse(content);
      if (parsed.root) {
        // Lexical形式の場合 - 直接JSONを解析
        const html = renderLexicalNode(parsed.root);
        
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
      }
    } catch (e) {
      // プレーンテキストの場合
    }

    // プレーンテキストの場合は改行で分割して表示
    return (
      <>
        {content.split('\n').map((line, index) => (
          <span key={index}>
            {line}
            {index < content.split('\n').length - 1 && <br />}
          </span>
        ))}
      </>
    );
  }, [content]);

  return renderedContent ? <div className={className}>{renderedContent}</div> : null;
}

// Lexicalノードを安全にHTMLに変換
function renderLexicalNode(node: any): string {
  if (!node) return '';
  

  // テキストノード
  if (node.type === 'text') {
    return escapeHtml(node.text || '');
  }

  // リンクノード
  if (node.type === 'link') {
    const url = validateUrl(node.url || '');
    if (!url) return renderChildren(node);
    
    return `<a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">${renderChildren(node)}</a>`;
  }

  // 段落ノード
  if (node.type === 'paragraph') {
    const children = renderChildren(node);
    return children ? `<p>${children}</p>` : '<p><br /></p>';
  }

  // ルートノードまたはその他のノード
  return renderChildren(node);
}

// 子ノードをレンダリング
function renderChildren(node: any): string {
  if (!node.children || !Array.isArray(node.children)) return '';
  
  return node.children.map((child: any) => renderLexicalNode(child)).join('');
}

// HTMLエスケープ
function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// URLバリデーション（http/httpsのみ許可）
function validateUrl(url: string): string | null {
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return url;
    }
  } catch {
    // 無効なURL
  }
  return null;
}